module.exports = __webpack_public_path__ + "img/logotype-北师大.40a60623.svg";